<script>
import { sortBy } from 'lodash'
import ExtraAsDetail from './extras/extra-as-detail'
import ExtraBreadcrumb from './extras/extra-breadcrumb'
import ExtraCategoryCards from './extras/extra-category-cards'
import ExtraCategoryList from './extras/extra-category-list'
import ExtraCategorySlider from './extras/extra-category-slider'
import ExtraCategoryTabs from './extras/extra-category-tabs'
import ExtraCategoryVideos from './extras/extra-category-videos'
import ExtraContent from './extras/extra-content'
import ExtraDownloadList from './extras/extra-download-list'
import ExtraEmailAntrag from './extras/extra-email-antrag'
import ExtraEvents from './extras/extra-events'
import ExtraFeedback from './extras/extra-feedback'
import ExtraFodynBuilder from './extras/extra-fodyn-builder'
import ExtraFodynPage from './extras/extra-fodyn-page'
import ExtraFormular from './extras/extra-formular'
import ExtraFormularResults from './extras/extra-formular-results'
import ExtraHtml from './extras/extra-html'
import ExtraGesundbox from './extras/extra-gesundbox'
import ExtraIchHabeEineIdee from './extras/extra-ich-habe-eine-idee'
import ExtraItTermineUebersicht from './extras/extra-it-termine-uebersicht'
import ExtraItTicketAufgeben from './extras/extra-it-ticket-aufgeben'
import ExtraItTicketCenter from './extras/extra-it-ticket-center'
import ExtraItTicketFreigabe from './extras/extra-it-ticket-freigabe'
import ExtraItTicketHistorie from './extras/extra-it-ticket-historie'
import ExtraItTicketStatistik from './extras/extra-it-ticket-statistik'
import ExtraItTicketVorgabenBearbeiten from './extras/extra-it-ticket-vorgaben-bearbeiten'
import ExtraItTicketVorgaengeBearbeiten from './extras/extra-it-ticket-vorgaenge-bearbeiten'
import ExtraItTicketVorgangAufgeben from './extras/extra-it-ticket-vorgang-aufgeben'
import ExtraJobsList from './extras/extra-jobs-list'
import ExtraLayoutsBearbeiten from './extras/extra-layouts-bearbeiten'
import ExtraLightbox from './extras/extra-lightbox'
import ExtraLinkCard from './extras/extra-link-card'
import ExtraMain from './extras/extra-main'
import ExtraMapStandorte from './extras/extra-map-standorte'
import ExtraMeineTickets from './extras/extra-meine-tickets'
import ExtraMeinProfil from './extras/extra-mein-profil'
import ExtraMeinProjekt from './extras/extra-mein-projekt'
import ExtraMeinSchreibtisch from './extras/extra-mein-schreibtisch'
import ExtraMenusBearbeiten from './extras/extra-menus-bearbeiten'
import ExtraNotification from './extras/extra-notification'
import ExtraPDetail from './extras/extra-p-detail'
import ExtraParentContainer from './extras/extra-parent-container'
import ExtraParentTabs from './extras/extra-parent-tabs'
import ExtraPasswordReset from './extras/extra-password-reset'
import ExtraPatientenverfuegung from './extras/extra-patientenverfuegung'
import ExtraProjektliste from './extras/extra-projektliste'
import ExtraProjektPlanung from './extras/extra-projekt-planung'
import ExtraProjekteStatus from './extras/extra-projekte-status'
import ExtraQuickndirtyEhrenamt from './extras/extra-quickndirty-ehrenamt'
import ExtraRegister from './extras/extra-register'
import ExtraSearch from './extras/extra-search'
import ExtraSearchResults from './extras/extra-search-results'
import ExtraShopFreigabe from './extras/extra-shop-freigabe'
import ExtraSocialWall from './extras/extra-social-wall'
import ExtraTelefonliste from './extras/extra-telefonliste'
import ExtraTicketDetail from './extras/extra-ticket-detail'
import ExtraToolbox from './extras/extra-toolbox'
import ExtraUnknown from './extras/extra-unknown'
import ExtraWikiIndex from './extras/extra-wiki-index'
import gql from 'graphql-tag'

const Components = {
  'as-detail': ExtraAsDetail,
  'breadcrumb': ExtraBreadcrumb,
  'category_videos': ExtraCategoryVideos,
  'category-cards': ExtraCategoryCards,
  'category-tabs': ExtraCategoryTabs,
  'content_slider': ExtraCategorySlider,
  'content': ExtraContent,
  'contents_newest': ExtraCategoryList,
  'download-list': ExtraDownloadList,
  'email-antrag': ExtraEmailAntrag,
  'events': ExtraEvents,
  'feedback': ExtraFeedback,
  'fodyn-builder': ExtraFodynBuilder,
  'fodyn-page': ExtraFodynPage,
  'formular-results': ExtraFormularResults,
  'formular': ExtraFormular,
  'gesundbox': ExtraGesundbox,
  'html': ExtraHtml,
  'ich-habe-eine-idee': ExtraIchHabeEineIdee,
  'it-termine-uebersicht': ExtraItTermineUebersicht,
  'it-ticket-aufgeben': ExtraItTicketAufgeben,
  'it-ticket-center': ExtraItTicketCenter,
  'it-ticket-freigabe': ExtraItTicketFreigabe,
  'it-ticket-historie': ExtraItTicketHistorie,
  'it-ticket-statistik': ExtraItTicketStatistik,
  'it-ticket-vorgaben-bearbeiten': ExtraItTicketVorgabenBearbeiten,
  'it-ticket-vorgaenge-bearbeiten': ExtraItTicketVorgaengeBearbeiten,
  'it-ticket-vorgang-aufgeben': ExtraItTicketVorgangAufgeben,
  'jobs-list': ExtraJobsList,
  'layouts-bearbeiten': ExtraLayoutsBearbeiten,
  'lightbox': ExtraLightbox,
  'link-card': ExtraLinkCard,
  'main': ExtraMain,
  'map_standorte': ExtraMapStandorte,
  'mein-profil': ExtraMeinProfil,
  'mein-projekt': ExtraMeinProjekt,
  'mein-schreibtisch': ExtraMeinSchreibtisch,
  'meine_tickets': ExtraMeineTickets,
  'menus-bearbeiten': ExtraMenusBearbeiten,
  'notification': ExtraNotification,
  'p-detail': ExtraPDetail,
  'parent-container': ExtraParentContainer,
  'parent-tabs': ExtraParentTabs,
  'password-reset': ExtraPasswordReset,
  'patientenverfuegung': ExtraPatientenverfuegung,
  'projekt-planung': ExtraProjektPlanung,
  'projekte-status': ExtraProjekteStatus,
  'projektliste': ExtraProjektliste,
  'quickndirty-ehrenamt': ExtraQuickndirtyEhrenamt,
  'register': ExtraRegister,
  'search-results': ExtraSearchResults,
  'search': ExtraSearch,
  'shop-freigabe': ExtraShopFreigabe,
  'social-wall': ExtraSocialWall,
  'telefonliste': ExtraTelefonliste,
  'ticket-detail': ExtraTicketDetail,
  'toolbox': ExtraToolbox,
  'unknown': ExtraUnknown,
  'wiki-index': ExtraWikiIndex,
}

export { Components }

function sizeAttrs(column) {
  const attrs = {};
  let lastSize = -1;
  ['xs', 'sm', 'md', 'lg', 'xl'].forEach(sizeName => {
    const size = column[sizeName]
    if (lastSize !== size) {
      lastSize = size
      attrs[`${sizeName}${size}`] = true
    }
  })
  return attrs
}

function calculateGridSize(columns) {
  const widthTotals = { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }
  columns.forEach(({ column }) => {
    column.xs = (column.xs || 12) - 0
    column.sm = (column.sm || column.xs) - 0
    column.md = (column.md || column.sm) - 0
    column.lg = (column.lg || column.md) - 0
    column.xl = (column.xl || column.lg) - 0
    widthTotals.xs += column.xs
    widthTotals.sm += column.sm
    widthTotals.md += column.md
    widthTotals.lg += column.lg
    widthTotals.xl += column.xl
  })
  while (true) {
    let grew = false
    let growFactors = {
      xs: (12.0 - widthTotals.xs) / widthTotals.xs,
      sm: (12.0 - widthTotals.sm) / widthTotals.sm,
      md: (12.0 - widthTotals.md) / widthTotals.md,
      lg: (12.0 - widthTotals.lg) / widthTotals.lg,
      xl: (12.0 - widthTotals.xl) / widthTotals.xl
    }
    columns.forEach(({ column }) => {
      Object.entries(growFactors).forEach(([size, growFactor]) => {
        if (!column.grow) {
          return
        }
        let grow = Math.ceil(column[size] * growFactor)
        if (!(grow > 0 && widthTotals[size] + grow <= 12)) {
          return
        }
        grew = true
        widthTotals[size] += grow
        column[size] += grow
      })
    })
    if (!grew || Object.values(widthTotals).every(width => width >= 12)) {
      break
    }
  }
}

export default {
  props: ['menu', 'isPage'],
  data() {
    return {
      rows: [],
      extraPositions: {}
    }
  },
  apollo: {
    extrasLayouts: {
      query: gql`query LayoutVue($layoutId: ID, $menuId: ID, $pageId: ID) {
        layouts(where: { id: $layoutId }) { id name positions }
        extras(order: "order", menuId: $menuId, pageId: $pageId, where: { state: "published" }) { id name state content visible options order showOnAllMenus }
      }`,
      fetchPolicy: 'no-cache',
      update(data) {
        if (!data.layouts || !data.extras) {
          return
        }

        if (data.layouts[0] && data.layouts[0].positions) {
          this.rows = JSON.parse(data.layouts[0].positions)
        } else {
          this.rows = []
        }

        const allExtras = sortBy(data.extras, 'order').map(extra => {
          return { ...extra, options: JSON.parse(extra.options) }
        })

        const extras = allExtras.filter(extra => {
          const parent_id = extra.options.parent_id
          const parent = parent_id && allExtras.find(e => e.id == parent_id)
          if (parent) {
            parent.children = parent.children || []
            parent.children.push(extra)
          } else {
            return true
          }
        })

        const extraPositions = {}
        extras.forEach(extra => {
          const position = extra.options.position
          if (position !== 'footer' && position !== 'mainmenu') {
            extraPositions[position] = extraPositions[position] || []
            extraPositions[position].push(extra)
          }
        })
        this.extraPositions = extraPositions
      },
      variables() {
        return {
          layoutId: this.menu.layoutId,
          menuId: this.menu.id,
          pageId: this.$route.params.slug
        }
      },
      skip() {
        return !this.menu.id
      }
    }
  },
  render(h) {
    const extraPositions = this.extraPositions
    const menuId = this.menu.id

    const rowElements = []
    this.rows.forEach(row => {
      const visibleColumns = []
      row.columns.forEach(column => {
        const extraElements = []
        ;(extraPositions[column.name] || []).forEach(extra => {
          if (extra.visible) {
            let component = Components[extra.options.kind] || Components['unknown']
            extraElements.push(h(component, { props: { extra, isPage: this.isPage, menu: this.menu }, class: extra.options.add_class }))
          }
        })
        if (extraElements.length) {
          visibleColumns.push({ column, extraElements })
        }
      })
      if (visibleColumns.length) {
        calculateGridSize(visibleColumns)

        const columnElements = visibleColumns.map(({ column, extraElements }) => {
          return h('v-flex', { attrs: sizeAttrs(column) }, extraElements)
        })

        const rowElement = h('v-layout', { class: 'row wrap' }, columnElements)
        if (row.container) {
          rowElements.push(h('v-container', { class: 'my-3 py-0 grid-list-lg', attrs: { fluid: row.container_fluid } }, [rowElement]))
        } else {
          rowElements.push(rowElement)
        }
      }
    })

    return h('v-content', rowElements)
  }
}
</script>
